import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown, Menu, X } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { programs } from '../data/siteData';
import { assetPath } from '../utils/assetPath';

const homeSection = (section) => `${import.meta.env.BASE_URL}#${section}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  const [programsOpen, setProgramsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setProgramsOpen(false);
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <a className="skip-link" href="#contenido">Saltar al contenido</a>
      <header className="site-header">
        <div className="topline">
          <div className="shell topline__inner">
            <span>31 años transformando oportunidades en historias</span>
            <a href="tel:+522299842590">+52 229 984 2590</a>
          </div>
        </div>
        <div className="shell nav-shell">
          <Link className="brand" to="/" aria-label="Fundación Tony, inicio">
            <img src={assetPath('/assets/brand/logo-fundacion-square.png')} alt="" />
          </Link>

          <nav className="desktop-nav" aria-label="Navegación principal">
            <NavLink to="/" end>Inicio</NavLink>
            <a href={homeSection('nosotros')}>Nosotros</a>
            <div className="nav-dropdown">
              <button type="button" aria-haspopup="true">
                Programas <ChevronDown size={15} />
              </button>
              <div className="nav-dropdown__panel">
                {programs.map((program) => {
                  const Icon = program.icon;
                  return (
                    <Link key={program.id} to={program.path}>
                      <span className={`nav-program-icon nav-program-icon--${program.theme}`}><Icon size={18} /></span>
                      <span>{program.shortTitle}<small>{program.eyebrow}</small></span>
                    </Link>
                  );
                })}
              </div>
            </div>
            <a href={homeSection('actualidad')}>Galería</a>
            <NavLink to="/contacto">Contacto</NavLink>
          </nav>

          <Link className="button button--small nav-cta" to="/contacto">Quiero ayudar</Link>
          <button className="menu-toggle" type="button" onClick={() => setOpen(true)} aria-label="Abrir menú">
            <Menu />
          </button>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="mobile-menu__panel"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', stiffness: 310, damping: 32 }}
            >
              <div className="mobile-menu__head">
                <img src={assetPath('/assets/brand/logo-fundacion-square.png')} alt="Fundación Tony" />
                <button type="button" onClick={() => setOpen(false)} aria-label="Cerrar menú"><X /></button>
              </div>
              <nav aria-label="Navegación móvil">
                <Link to="/">Inicio</Link>
                <a href={homeSection('nosotros')}>Nosotros</a>
                <button className="mobile-programs-trigger" type="button" onClick={() => setProgramsOpen(!programsOpen)}>
                  Programas <ChevronDown className={programsOpen ? 'rotate' : ''} size={18} />
                </button>
                <AnimatePresence initial={false}>
                  {programsOpen && (
                    <motion.div
                      className="mobile-submenu"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                    >
                      {programs.map((program) => <Link key={program.id} to={program.path}>{program.shortTitle}</Link>)}
                    </motion.div>
                  )}
                </AnimatePresence>
                <a href={homeSection('actualidad')}>Galería</a>
                <Link to="/contacto">Contacto</Link>
              </nav>
              <Link className="button" to="/contacto">Quiero ayudar</Link>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
